module.exports = __webpack_public_path__ + "northernTrust.1cce09d100091c784ac9fac9fb600532.svg";